import React from "react";
import { Box, Button, TextField } from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import BtnSecondary from "../../../application/components/Button/BtnSecondary";
import { makeStyles } from "@mui/styles";
import ProfileSuccessModal from "../../components/Dashboard/Modals/ProfileSuccessModal";

const style = {
  bgcolor: "background.paper",
  boxShadow: 0,
  p: 4,
  borderRadius: "8px",
  marginTop: ".5rem",
};

const headerStyle = {
  color: "#292727",
  fontFamily: "Inter",
  fontSize: "1.5rem",
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: "normal",
};

const useStyles = makeStyles(() => ({
  root: {
    "& .MuiOutlinedInput-root": {
      borderRadius: "8px",
      "&:hover:not(.Mui-focused) .MuiOutlinedInput-notchedOutline": {
        borderColor: "#98A2B3",
      },
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      border: "1px solid #98A2B3",
      borderRadius: "8px",
    },
  },
}));

export default function CandidateOverviewPage() {
  const [gender, setGender] = React.useState("male");
  const [open, setOpen] = React.useState(false);
  const classes = useStyles();

  const handleGenderChange = (event) => {
    setGender(event.target.value);
  };

  const handleClick = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Box sx={style}>
      <form>
        <div className="flex justify-between items-center">
          <p className="header-style" style={headerStyle}>
            Please complete your profile, fill out the empty fields.
          </p>
        </div>
        <section className="mt-[1.5rem]">
          <div className="flex items-center flex-col md:flex-row gap-[1.5rem]">
            <svg
              width="150"
              height="150"
              viewBox="0 0 150 150"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M92.94 53H87.06C85.32 53 84.04 53.72 83.46 55C83.14 55.58 83 56.26 83 57.06V62.94C83 65.48 84.52 67 87.06 67H92.94C93.74 67 94.42 66.86 95 66.54C96.28 65.96 97 64.68 97 62.94V57.06C97 54.52 95.48 53 92.94 53ZM94.82 60.86C94.62 61.06 94.32 61.2 94 61.22H91.18V62.24L91.2 64C91.18 64.34 91.06 64.62 90.82 64.86C90.62 65.06 90.32 65.2 90 65.2C89.34 65.2 88.8 64.66 88.8 64V61.2L86 61.22C85.34 61.22 84.8 60.66 84.8 60C84.8 59.34 85.34 58.8 86 58.8L87.76 58.82H88.8V56.02C88.8 55.36 89.34 54.8 90 54.8C90.66 54.8 91.2 55.36 91.2 56.02L91.18 57.44V58.8H94C94.66 58.8 95.2 59.34 95.2 60C95.18 60.34 95.04 60.62 94.82 60.86Z"
                fill="#1E87FF"
              />
              <path
                d="M69.0002 71.7583C71.6291 71.7583 73.7602 69.6272 73.7602 66.9983C73.7602 64.3694 71.6291 62.2383 69.0002 62.2383C66.3714 62.2383 64.2402 64.3694 64.2402 66.9983C64.2402 69.6272 66.3714 71.7583 69.0002 71.7583Z"
                fill="#1E87FF"
              />
              <path
                d="M92.94 67H92V76.22L91.74 76C90.18 74.66 87.66 74.66 86.1 76L77.78 83.14C76.22 84.48 73.7 84.48 72.14 83.14L71.46 82.58C70.04 81.34 67.78 81.22 66.18 82.3L58.7 87.32C58.26 86.2 58 84.9 58 83.38V66.62C58 60.98 60.98 58 66.62 58H83V57.06C83 56.26 83.14 55.58 83.46 55H66.62C59.34 55 55 59.34 55 66.62V83.38C55 85.56 55.38 87.46 56.12 89.06C57.84 92.86 61.52 95 66.62 95H83.38C90.66 95 95 90.66 95 83.38V66.54C94.42 66.86 93.74 67 92.94 67Z"
                fill="#1E87FF"
              />
              <rect
                x="0.5"
                y="0.5"
                width="149"
                height="149"
                rx="7.5"
                stroke="#1E87FF"
              />
            </svg>
            <BtnSecondary
              variant="contained"
              size="large"
              text="Upload Image"
              height="56px"
            ></BtnSecondary>
          </div>
        </section>

        <section className="mt-8">
          <div className="mt-4">
            <p className="font-semibold mb-2 text-[12px] text-[#98A2B3]">
              Last name
            </p>
            <TextField
              id="outlined-basic"
              variant="outlined"
              className={`w-full ${classes.root}`}
            />
          </div>

          <div className="mt-4">
            <p className="font-semibold mb-2 text-[12px] text-[#98A2B3]">
              First name
            </p>
            <TextField
              id="outlined-basic"
              variant="outlined"
              className={`w-full ${classes.root}`}
            />
          </div>

          <div className="mt-4">
            <p className="font-semibold mb-2 text-[12px] text-[#98A2B3]">
              Address
            </p>
            <TextField
              id="outlined-basic"
              variant="outlined"
              className={`w-full ${classes.root}`}
            />
          </div>

          <div className="mt-4">
            <p className="font-semibold mb-2 text-[12px] text-[#98A2B3]">
              Phone number
            </p>
            <TextField
              id="outlined-basic"
              variant="outlined"
              className={`w-full ${classes.root}`}
            />
          </div>

          <div className="mt-4">
            <p className="font-semibold mb-2 text-[12px] text-[#98A2B3]">
              Email Address
            </p>
            <TextField
              id="outlined-basic"
              variant="outlined"
              className={`w-full ${classes.root}`}
              type="email"
            />
          </div>

          <div className="mt-4 w-full">
            <p className="font-semibold mb-2 text-[12px] text-[#98A2B3]">
              Date of birth
            </p>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DemoContainer components={["DatePicker"]}>
                <DatePicker className={`w-full ${classes.root}`} />
              </DemoContainer>
            </LocalizationProvider>
          </div>

          <div className="mt-4">
            <p className="font-semibold mb-2 text-[12px] text-[#98A2B3]">
              Location
            </p>
            <TextField
              id="outlined-basic"
              variant="outlined"
              className={`w-full ${classes.root}`}
            />
          </div>

          <div className="mt-4">
            <p className="font-semibold mb-2 text-[12px] text-[#98A2B3]">
              Gender
            </p>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={gender}
              onChange={handleGenderChange}
              className={`w-full ${classes.root}`}
            >
              <MenuItem value={"male"}>Male</MenuItem>
              <MenuItem value={"female"}>Female</MenuItem>
            </Select>
          </div>

          <div className="mt-4">
            <p className="font-semibold mb-2 text-[12px] text-[#98A2B3]">
              Next of kin name
            </p>
            <TextField
              id="outlined-basic"
              variant="outlined"
              className={`w-full ${classes.root}`}
            />
          </div>

          <div className="mt-4">
            <p className="font-semibold mb-2 text-[12px] text-[#98A2B3]">
              Next of kin relationship
            </p>
            <TextField
              id="outlined-basic"
              variant="outlined"
              className={`w-full ${classes.root}`}
            />
          </div>

          <div className="mt-4">
            <p className="font-semibold mb-2 text-[12px] text-[#98A2B3]">
              Next of kin phone
            </p>
            <TextField
              id="outlined-basic"
              variant="outlined"
              className={`w-full ${classes.root}`}
            />
          </div>

          <div className="mt-4">
            <p className="font-semibold mb-2 text-[12px] text-[#98A2B3]">
              Marital status
            </p>
            <TextField
              id="outlined-basic"
              variant="outlined"
              className={`w-full ${classes.root}`}
            />
          </div>

          <div className="mt-4">
            <p className="font-semibold mb-2 text-[12px] text-[#98A2B3]">Bio</p>
            <TextField
              id="filled-multiline-static"
              variant="outlined"
              multiline
              rows={4}
              className={`w-full ${classes.root}`}
            />
          </div>

          <div className="flex justify-end mt-4 profile">
            <Button
              variant="contained"
              size="large"
              onClick={handleClick}
              className="py-5"
              style={{ boxShadow: "none" }}
            >
              Save Changes
            </Button>
          </div>
        </section>
      </form>
      {open && <ProfileSuccessModal onClose={() => handleClose()} />}
    </Box>
  );
}
